import { useFormContext } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Textarea } from '../ui/textarea';
import { cn } from '@/lib/utils';

interface Props {
    className?: string;
    name: string;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    value?: string;
}

export default function TextAreaInputForm({ className, name, label, placeholder, disabled, value }: Props) {
    const { control } = useFormContext();
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel className="text-primery-blue-900 font-medium text-[18px] leading-[33.73px] tracking-normal text-start">
                        {label}
                    </FormLabel>
                    <FormControl>
                        <Textarea
                            disabled={disabled}
                            {...field}
                            className={cn('placeholder:text-white-blue-600', className)}
                            placeholder={placeholder}
                        />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
